import { useDispatch, useSelector } from "react-redux";
import {
  Badge,
  Button,
  Container,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import {
  purgeClient,
  resumeClient,
  suspendClient,
} from "src/store/client-lifecycle/saga";
import Loader from "src/components/Loader";
import ClientEditForm from "../Clients/edit";
import { ClientDetailDto } from "src/store/clients/type";
import { useAppSelector } from "src/store";
import { getClientDetails } from "src/store/clients/saga";
import Breadcrumb from "src/components/Common/Breadcrumb";
import CustomNavbar from "src/components/Navbar";
import CustomTabContent from "src/components/TabContent";
import ClientPurchasedPackagesTab from "./clients-packages";
import ClientDashboardTab from "./clients-dashboard";
import ClientLocationsTab from "./clients-locations";
import ClientCalllogsTab from "./clients-calllogs";
import ClientWebMailTab from "./clients-webmail";

const ClientDetailPage = () => {
  const dispatch = useDispatch();
  const { tab, id } = useParams<{ tab: string; id: string }>();
  const [active, setActive] = useState(tab ?? "1");
  const [selected, setSelected] = useState<ClientDetailDto>();
  const [showEdit, setShowEdit] = useState<boolean>(false);
  const [delOpen, setDelOpen] = useState(false);
  const [mode, setMode] = useState<"soft" | "hard">("soft");
  const [confirmName, setConfirmName] = useState("");
  const [busy, setBusy] = useState("");
  const navigate = useNavigate();
  const loading = useAppSelector((s) => s.loading.loading);
  const { t } = useTranslation();
  const toogle = (e: any) => {
    return navigate("/clients/details/" + e + "/" + id);
  };

  const reload = () =>
    dispatch(
      getClientDetails({
        payload: {
          onSuccess: (_m: any, p: ClientDetailDto) => setSelected(p),
          onError: () => {},
        },
        id: id,
      })
    );

  const doSuspend = () => {
    setBusy("suspend");
    dispatch(
      suspendClient({
        id,
        payload: {
          onSuccess: () => {
            setBusy("");
            toast.success(t("Lifecycle.Suspended", "Müşteri askıya alındı."));
            reload();
          },
          onError: (m: string) => {
            setBusy("");
            toast.error(m || t("Lifecycle.Error", "İşlem başarısız."));
          },
        },
      })
    );
  };

  const doResume = () => {
    setBusy("resume");
    dispatch(
      resumeClient({
        id,
        payload: {
          onSuccess: () => {
            setBusy("");
            toast.success(t("Lifecycle.Resumed", "Müşteri geri açıldı."));
            reload();
          },
          onError: (m: string) => {
            setBusy("");
            toast.error(m || t("Lifecycle.Error", "İşlem başarısız."));
          },
        },
      })
    );
  };

  const doPurge = () => {
    setBusy("purge");
    dispatch(
      purgeClient({
        id,
        body: { Mode: mode, Confirm: confirmName },
        payload: {
          onSuccess: () => {
            setBusy("");
            setDelOpen(false);
            setConfirmName("");
            toast.success(t("Lifecycle.Purged", "Müşteri verileri silindi (ticari kayıt korundu)."));
            reload();
          },
          onError: (m: string) => {
            setBusy("");
            toast.error(m || t("Lifecycle.Error", "İşlem başarısız."));
          },
        },
      })
    );
  };
  useEffect(() => {
    tab && setActive(tab);
  }, [tab]);
  useEffect(() => {
    dispatch(
      getClientDetails({
        payload: {
          onSuccess: (message, payload) => {
            setSelected(payload);
          },
          onError: () => {},
        },
        id: id,
      })
    );
  }, [dispatch, id]);
  useEffect(() => {
    tab === "1" &&
      dispatch(
        getClientDetails({
          payload: {
            onSuccess: (message, payload) => {
              setSelected(payload);
            },
            onError: () => {},
          },
          id: id,
        })
      );
  }, [dispatch, tab, id]);
  return (
    <React.Fragment>
      <div className="page-content">
        {loading && <Loader />}
        {selected && (
          <Container fluid>
            <div className="m-crumb">
              <Link to="/clients">{t("Menu.Clients")}</Link>
              <i className="mdi mdi-chevron-right" />
              <span>{selected.ClientName}</span>
            </div>
            <div className="client-header">
              <div className="client-header__id">
                <div className="client-header__avatar">
                  {(selected.ClientName || "?")
                    .split(" ")
                    .filter(Boolean)
                    .slice(0, 2)
                    .map((w: string) => w[0])
                    .join("")
                    .toUpperCase()}
                </div>
                <div className="client-header__info">
                  <div className="client-header__name">
                    {selected.ClientName}
                    {selected.Closed ? (
                      <span className="badge bg-soft-danger">
                        {t("Lifecycle.Closed", "Kapatıldı")}
                      </span>
                    ) : selected.Suspended ? (
                      <span className="badge bg-soft-warning">
                        {t("Lifecycle.StatusSuspended", "Askıda")}
                      </span>
                    ) : (
                      <span className="badge bg-soft-success">
                        {t("Lifecycle.StatusActive", "Aktif")}
                      </span>
                    )}
                  </div>
                  <div className="client-header__meta">
                    {selected.SectorName && (
                      <span><i className="mdi mdi-briefcase-outline" /> {selected.SectorName}</span>
                    )}
                    {selected.CorporateEmail && (
                      <span><i className="mdi mdi-email-outline" /> {selected.CorporateEmail}</span>
                    )}
                    {selected.CorporatePhone && (
                      <span><i className="mdi mdi-phone-outline" /> {selected.CorporatePhone}</span>
                    )}
                  </div>
                </div>
              </div>
              <div className="client-header__actions">
                <Button
                  className="btn-sm btn-soft-primary"
                  onClick={() => setShowEdit(true)}
                >
                  <i className="mdi mdi-pencil-outline me-1" />
                  {t("Clients.EditButton")}
                </Button>
                {!selected.Closed &&
                  (selected.Suspended ? (
                    <Button className="btn-sm" color="success" disabled={busy !== ""} onClick={doResume}>
                      {t("Lifecycle.Resume", "Askıyı Kaldır")}
                    </Button>
                  ) : (
                    <Button className="btn-sm" color="warning" disabled={busy !== ""} onClick={doSuspend}>
                      {t("Lifecycle.Suspend", "Askıya Al")}
                    </Button>
                  ))}
                {!selected.Closed && (
                  <Button
                    className="btn-sm"
                    color="danger"
                    outline
                    onClick={() => {
                      setMode("soft");
                      setConfirmName("");
                      setDelOpen(true);
                    }}
                  >
                    {t("Lifecycle.Delete", "Müşteriyi Sil")}
                  </Button>
                )}
              </div>
            </div>
            <div className=" w-100 mt-3">
              <CustomNavbar
                className="detailPageNavMenu contactNavbar"
                active={active}
                onSelect={(t) => toogle(t)}
                navlist={[
                  {
                    key: "1",
                    title: "Clients.Menu.Dashboard",
                  },
                  {
                    key: "2",
                    title: "Clients.Menu.Packages",
                  },
                  {
                    key: "3",
                    title: "Clients.Menu.Locations",
                  },
                  {
                    key: "4",
                    title: "Clients.Menu.Calllogs",
                  },
                  {
                    key: "5",
                    title: "Clients.Menu.WebMail",
                  },
                ]}
              />
              <CustomTabContent
                className="detailPageNavMenu"
                active={active}
                list={[
                  {
                    key: "1",
                    component: <ClientDashboardTab client={selected} />,
                  },
                  {
                    key: "2",
                    grid: true,
                    component: (
                      <ClientPurchasedPackagesTab
                        active={active}
                        client={selected}
                      />
                    ),
                  },
                  {
                    key: "3",
                    grid: true,
                    component: (
                      <ClientLocationsTab active={active} client={selected} />
                    ),
                  },
                  {
                    key: "4",
                    grid: true,
                    component: (
                      <ClientCalllogsTab active={active} client={selected} />
                    ),
                  },
                  {
                    key: "5",
                    grid: true,
                    component: (
                      <ClientWebMailTab active={active} client={selected} />
                    ),
                  },
                ]}
              />
            </div>
            <ClientEditForm
              onHide={() => setShowEdit(true)}
              onSuccessClick={() =>
                dispatch(
                  getClientDetails({
                    payload: {
                      onSuccess: (message, payload) => {
                        setSelected(payload);
                      },
                      onError: () => {},
                    },
                    id: id,
                  })
                )
              }
              open={showEdit}
              data={selected}
            />

            {/* Müşteriyi Sil — soft/hard seçim + isim onayı */}
            <Modal isOpen={delOpen} toggle={() => setDelOpen(false)} centered>
              <ModalHeader toggle={() => setDelOpen(false)}>
                {t("Lifecycle.DeleteTitle", "Müşteriyi Sil")}
              </ModalHeader>
              <ModalBody>
                <p className="text-muted" style={{ fontSize: 13 }}>
                  {t(
                    "Lifecycle.DeleteDesc",
                    "Müşterinin app'te girdiği tüm veriler (araçlar, sözleşmeler, müşteriler, web sitesi, posta kutuları vb.) silinir. Aldığı paketler ve ödeme kayıtları (ticari veri) KORUNUR; müşteri 'Kapatıldı' olarak işaretlenir."
                  )}
                </p>

                <div className="mb-2">
                  <Label className="d-block mb-1" style={{ fontWeight: 600, fontSize: 13 }}>
                    {t("Lifecycle.Mode", "Silme türü")}
                  </Label>
                  <div
                    className="form-check"
                    style={{ cursor: "pointer" }}
                    onClick={() => setMode("soft")}
                  >
                    <Input
                      type="radio"
                      name="deleteMode"
                      id="mode-soft"
                      checked={mode === "soft"}
                      onChange={() => setMode("soft")}
                    />
                    <Label for="mode-soft" className="form-check-label" style={{ cursor: "pointer" }}>
                      {t(
                        "Lifecycle.ModeSoft",
                        "Soft — veriler gizlenir/pasifleşir (geri dönülebilir), posta kutuları askıya alınır"
                      )}
                    </Label>
                  </div>
                  <div
                    className="form-check"
                    style={{ cursor: "pointer" }}
                    onClick={() => setMode("hard")}
                  >
                    <Input
                      type="radio"
                      name="deleteMode"
                      id="mode-hard"
                      checked={mode === "hard"}
                      onChange={() => setMode("hard")}
                    />
                    <Label
                      for="mode-hard"
                      className="form-check-label text-danger"
                      style={{ cursor: "pointer" }}
                    >
                      {t(
                        "Lifecycle.ModeHard",
                        "Hard — veriler KALICI silinir (geri alınamaz), posta kutuları kaldırılır"
                      )}
                    </Label>
                  </div>
                </div>

                {mode === "hard" && (
                  <p className="text-danger mb-2" style={{ fontSize: 13 }}>
                    <b>{t("Lifecycle.HardWarn", "Bu işlem geri alınamaz.")}</b>
                  </p>
                )}

                <p className="mb-1" style={{ fontSize: 13 }}>
                  {t("Lifecycle.ConfirmLabel", "Onaylamak için müşteri adını yazın:")}{" "}
                  <code>{selected.ClientName}</code>
                </p>
                <Input
                  value={confirmName}
                  onChange={(e) => setConfirmName(e.target.value)}
                  placeholder={selected.ClientName}
                />
              </ModalBody>
              <ModalFooter>
                <Button color="light" onClick={() => setDelOpen(false)}>
                  {t("Lifecycle.Cancel", "Vazgeç")}
                </Button>
                <Button
                  color="danger"
                  disabled={
                    busy === "purge" ||
                    confirmName.trim().toLowerCase() !==
                      (selected.ClientName || "").trim().toLowerCase()
                  }
                  onClick={doPurge}
                >
                  {mode === "hard"
                    ? t("Lifecycle.ConfirmHard", "Kalıcı Olarak Sil")
                    : t("Lifecycle.ConfirmSoft", "Sil (geri dönülebilir)")}
                </Button>
              </ModalFooter>
            </Modal>
          </Container>
        )}
      </div>
    </React.Fragment>
  );
};
export default ClientDetailPage;
